import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { PosmSubitem } from "../../models/posm-subitem.model";

@Injectable()
export class PosmSubitemProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByParentID(parentId: number, parentType: string): Observable<PosmSubitem[]> {
    return this.http
      .get<PosmSubitem[]>(`${this.url}/posm-subitems/${parentId}/` + (parentType === 'POSM_CATEGORY'? 'posm-category' : 'posm-item'))
      .map(response => {
        return response.map((posmSubitem) => {
          let posmSubitemInstance = new PosmSubitem(posmSubitem);
          if (!posmSubitemInstance.asked_quantity) {
            posmSubitemInstance.asked_quantity = 0;
          }
          return posmSubitemInstance;
        });
      })
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/providers/posm-subitem/posm-subitem.ts